// src/components/users/Users.jsx
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Plus } from 'lucide-react';
import { UserList } from './UserList';
import { UserProfile } from './UserProfile';

export const Users = () => {
  const { user } = useAuth();
  const [showCreateUser, setShowCreateUser] = useState(false);

  const canCreateUsers = user.role === 'admin';

  return (
    <div className="p-6">
      <div className="mb-6 flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900">Users</h1>
        {canCreateUsers && (
          <button
            onClick={() => setShowCreateUser(true)}
            className="flex items-center px-4 py-2 bg-uzima-maroon-500 text-white rounded-md hover:bg-uzima-maroon-600"
          >
            <Plus className="h-5 w-5 mr-2" />
            Create User
          </button>
        )}
      </div>

      {/* Main content */}
      <UserList />

      {/* Create User Modal */}
      {showCreateUser && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full">
            <UserProfile
              isCreating={true}
              onComplete={() => setShowCreateUser(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
};
